'use client';

import { observer } from 'mobx-react-lite';
import { SearchEventResult } from 'searchEvent.d';
import { ParamsResult } from 'ParamsResult';
import { useMemo, useRef } from 'react';
import SearchEventList from 'components/SearchEventList/SearchEventList';
import { Pagination } from '@sympla/sympla-components';
import { PaginationExtraLabel } from 'components/Shared';
import { componentTrackingSearch } from 'constants/search';
import { MATRIX_TYPE } from 'constants/index';

import { Title, Container } from './ListEventsCollection.css';

function ListEventsCollection({
  dataSectionMoreEvents,
  serviceParams,
  isMobile,
  fecthEvents,
  isLoading,
  label,
  isCityCollection,
  matrixUuid,
}: {
  dataSectionMoreEvents: SearchEventResult;
  serviceParams?: ParamsResult;
  isMobile: boolean;
  isLoading: boolean;
  fecthEvents: (query: string) => void;
  label: string;
  isCityCollection: boolean;
  matrixUuid?: string;
}) {
  const totalPages = useMemo(() => {
    if (!dataSectionMoreEvents?.limit) return 1;
    if (dataSectionMoreEvents.total <= dataSectionMoreEvents.limit) return 0;
    return Math.ceil(dataSectionMoreEvents.total / dataSectionMoreEvents.limit);
  }, [dataSectionMoreEvents.limit, dataSectionMoreEvents.total]);

  const extraLabel = useMemo(
    () => (isMobile || totalPages <= 1
      ? <PaginationExtraLabel currentResults={dataSectionMoreEvents.data?.length} total={dataSectionMoreEvents.total} /> : <div />),
    [dataSectionMoreEvents.data, dataSectionMoreEvents.total, totalPages],
  );

  const containerListEventsRef = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={containerListEventsRef} className={Container}>
      <h2 className={Title}>
        Todos os eventos
        {isCityCollection && ` em ${label}`}
      </h2>
      <SearchEventList
        events={dataSectionMoreEvents.data}
        serviceParams={serviceParams}
        isMobile={isMobile}
        tracking={{
          label: componentTrackingSearch.sectionMoreEventsCollection,
          prefix: MATRIX_TYPE.MATRIX,
          cardType: 'event-card',
          matrizTemplate: matrixUuid,
        }}
      />
      <Pagination
        isLoading={isLoading}
        lang="pt"
        totalPages={totalPages}
        currentPage={Number(dataSectionMoreEvents.page)}
        onChangePage={(page: string | number) => {
          fecthEvents(`${window.location.search}&page=${page}`);
          if (!isMobile) {
            const containerTopPosition = containerListEventsRef?.current?.getBoundingClientRect()?.top;
            const offset = 120;
            if (containerTopPosition) window.scrollTo({ top: containerTopPosition + window.scrollY - offset, behavior: 'smooth' });
          }
          return +page;
        }}
        extraLabel={extraLabel}
        isMobile={isMobile}
      />
    </div>
  );
}

export default observer(ListEventsCollection);
